<div class="wm-l-capa-container">
  @if (!busy) {
    <wm-browserchooser class="wm-m-capa-chooser" [closeDetailsOnVersionSelect]="false" [browsers]="browsers" (browserChosen)="setActiveBrowser($event)"></wm-browserchooser>
    @if (chosenCapability !== undefined) {
      <div>
        <div class="wm-l-capa-code-container">
          <div class="wm-m-capa-code-container">
            @if (isMobileDevice) {
              <div class="wm-m-capa-code-heading">Format:</div>
              <div class="wm-m-capa-code-chooser">
                <p-select #dropdown
                          [style]="{width: '180px'}"
                          [(ngModel)]="selectedFormat"
                          [options]="[
                    { label: 'Java', value: 'java' },
                    { label: 'Appium Inspector', value: 'json' }
                  ]">
                </p-select>
              </div>
            }
            <div class="wm-m-capa-code-heading">
              {{ selectedFormat === 'java' ? 'Java' : 'Appium Inspector' }}
            </div>
            <div class="wm-m-capa-code" [innerHTML]="
            selectedFormat === 'java'
                ? getJavaCodeFromCapability(chosenCapability, true)
                : getJSONCodeFromCapability(chosenCapability, true) ">
            </div>
            <div class="clipboard-button-wrapper">
              <p-button (click)="copyToClipboard(chosenCapability)">
                <fa-icon [icon]="triggeredCopyToClipboard ? 'check' : 'clipboard'"></fa-icon>
                <span>{{ triggeredCopyToClipboard ? 'Copied To Clipboard' : 'Copy To Clipboard' }}</span>
              </p-button>
            </div>
          </div>
        </div>
      </div>

    }
  }

  <!-- launching the test -->
  @if (busy) {
    <div layout="row" layout-align="center" class="wm-l-capa-spinner-wrapper">
      <div>
        <div class="wm-l-capa-spinner-msg">Loading capabilities...</div>
        <p-progressSpinner class="wm-l-capa-spinner"></p-progressSpinner>
      </div>
    </div>
  }

</div>
